export function isGtmInlineScript(inputScript: string) {
    if (!inputScript) {
        return false;
    }
    return inputScript.includes('googletagmanager.com/gtm.js') || inputScript.includes('gtm.start') || inputScript.includes('event: "gtm.js"');
}
